import {ClientTypeType, DossierBool, DossierK} from "./base.model";
import {SvedULType} from "./svedULType.model";
import {SvedFLType} from "./svedFLType.model";
import {SvedIPType} from "./svedIPType.model";
import {SvedFLCPType} from "./svedFLCPType.model";
import {SvedInbULType} from "./svedInbULType.model";
import {PartItemArray} from "../partItemArray.model";
import {SvedKOType} from "./svedKOType.model";

export class ClientInfo extends PartItemArray {
  clientType: ClientTypeType = '';
  clientTrue: DossierK = '';
  rezidentRf: DossierBool = false;
  rezidentUsa?: DossierBool = false;
  rezidentFS?: DossierBool = false;
  nerezidentRF?: DossierBool = false;
  clientId: any = '';
  version: any = '';
  // items choice
  svedUL?: SvedULType = new SvedULType();
  svedKO?: SvedKOType = new SvedKOType();
  svedFL?: SvedFLType = new SvedFLType();
  svedIP?: SvedIPType = new SvedIPType();
  svedFLCP?: SvedFLCPType = new SvedFLCPType();
  svedInbUL?: SvedInbULType = new SvedInbULType();
}
